'use client'

import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(process.env.NEXT_PUBLIC_MUI_X_LICENSE_KEY)

export default function MuiLicense() {
  return null
}
